// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2RGHb","vLegacy":"SelectSecondary_vLegacy__ZTmJ1","error":"SelectSecondary_error__1XmSu","disabled":"SelectSecondary_disabled__2EE1s"};